import { BlockOverrides } from 'baseui/block';
import { StyleObject } from 'styletron-react';
import { THEME } from '@lyon/utils/theme';

const BASE_BLOCK: StyleObject = {
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  objectFit: 'cover',

  [THEME.media.small]: {
    height: '140px',
  },
  [THEME.media.medium]: {
    height: '180px',
  },
  [THEME.media.large]: {
    height: '220px',
  },
  [THEME.media.xlarge]: {
    height: '240px',
  },
};

export const ROUNDED: BlockOverrides = {
  Block: {
    style: {
      ...BASE_BLOCK,
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
  },
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      ...BASE_BLOCK,
    },
  },
};

export const COVER_SKELETON: StyleObject = {
  width: '100%',
  height: '100%',
};

export const IMAGE_SKELETON: StyleObject = {
  width: '100%',
  height: 'auto',
  objectFit: 'cover',
};
